import React from 'react';
import LateralMenuContent from '../LateralMenuContent';
import NotFoundError from '../../../../components/NotFoundError';

export default function AlunoFormMenu() {
    return (
        <LateralMenuContent child={NotFoundError} />
    );
}